var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkinColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#C99E81",
    width: "45px",
    height: "45px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.754 7.968a.447.447 0 0 1 .445-.445h.58a.447.447 0 0 1 .445.445v2.559l-.001.021.001.002v.525a4.936 4.936 0 0 1-3.107 4.38v1.322a.447.447 0 0 1-.446.446H2.63a.447.447 0 0 1-.445-.446v-1.502a2.77 2.77 0 0 1-1.408-2.55V4.07a.447.447 0 0 1 .446-.445h.46a.447.447 0 0 1 .445.445v3.502a.31.31 0 0 0 .62 0V2.55a.447.447 0 0 1 .446-.445h.46a.447.447 0 0 1 .445.445v4.37a.31.31 0 0 0 .62-.003V1.955a.447.447 0 0 1 .446-.446h.46a.447.447 0 0 1 .445.446v4.96a.31.31 0 0 0 .62 0V2.55a.447.447 0 0 1 .446-.445h.46a.447.447 0 0 1 .446.445v7.757a.356.356 0 0 0 .713 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinColor);
export default __webpack_public_path__ + "static/media/skinColor.ca7ce376ecd463635bf8f5449cf04c81.svg";
export { ForwardRef as ReactComponent };